<template>
    <Row>
        <Col span="12">
            <Select v-model="model12" :max-tag-count="2" @on-change="selectItems" filterable multiple>
                <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
        </Col>
    </Row>
</template>
<script>
    export default {
        name: "UserFeatureSelect",
        props: {
            cityList: {
                type: Array
            },
            selectedItems: {
                type: Array,
                default:()=>[]
            }
        },
        watch:{
            selectedItems(){
                this.model12 = this.selectedItems
            }
        },
        data() {
            return {
                model12: this.selectedItems
            }
        },
        methods: {
            selectItems(event) {
                let lastValue = event.slice(-1)[0];
                if (lastValue === 'selectAll'){
                    this.cityList[0].value = 'clearAll';
                    let allList = [];
                    this.cityList.forEach(items=>{
                        if(items.label !== '全选/清空'){
                            allList.push(items.value)
                        }
                    });
                    this.model12 = allList;
                } else if(lastValue === 'clearAll'){
                    this.cityList[0].value = 'selectAll';
                    this.model12 = [];
                }
                this.$emit("transmit", this.model12)
            },
        }
    }
</script>
<style scoped>
    .ivu-col-span-12 {
        width: 255px;
    }
</style>
